<template>
  <div>
    <DsfPlatformLogin></DsfPlatformLogin>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {};
  },
  methods: {},
};
</script>
